import React, { useEffect } from 'react';
import AppService from "s2s-app-service";
import Loading from '../components/loading';

const Login = ()=>{
  useEffect(() => {
    // redirect to CPaaS authentication if we don't have connect data
    let connectData = AppService.getInstance().getConnectData();

    if (connectData.account.uuid === "-1") {
      window.location.replace(`${window._env_.useTLS ? "https://" : "http://"}${window._env_.websocketHost}/login?app=starphonedesktop&callbackUrl=${window.location.origin}/connect`);
    } else {
      console.log('already have connect data...wait for auth data from appservice.reconnect()');
    }
  });

  return (
    <div className="loginRoute">
      <Loading />
    </div >
  );
}; 
export default Login;
